export enum CommonEnum {
  Language = 'language',
  AccessToken = 'token',
  RefreshToken = 'refreshToken',
}
